import {Injectable} from '@angular/core';
import {ApiService} from './api.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceTokenService {

  constructor(private apiService: ApiService) { }

  add(t: string, restaurantId: string) {
    return this.apiService.post<any>('/device-tokens/restaurants/' + restaurantId, {token: t}, true);
  }

  setDeviceToken(t: string) {
    return this.apiService.post<any>('/device-tokens', {token: t}, true);
  }

}
